import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaTab from './VaTab.vue'

export default withConfigTransport(VaTab)
